// OrderUploadDownload.jsx
import React, { useState } from 'react';
import axios from 'axios';

const OrderUploadDownload = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError('');
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file to upload.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
      await axios.post('https://astrovidhya.in/api/orders/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setMessage('Orders uploaded successfully.');
      setFile(null);
    } catch (err) {
      setError('Failed to upload orders.');
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axios.get('https://astrovidhya.in/api/orders/download', {
        responseType: 'blob', // Important for downloading files
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'orders.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setMessage('Orders downloaded successfully.');
    } catch (err) {
      setError('Failed to download orders.');
    }
  };

  return (
    <div className="container">
    {error && <div style={{ color: 'red' }}>{error}</div>}
    {message && <div style={{ color: 'green' }}>{message}</div>}
  
    <div className="flex justify-between items-center">
      <input 
        type="file" 
        accept=".csv" 
        onChange={handleFileChange} 
        className="flex-grow" 
      />
      <button 
        onClick={handleUpload} 
        className="bg-[#65737e] hover:bg-[#898989] text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300"
      >
        Upload Orders
      </button>
    </div>
    <br />
    <div>
      <button 
        onClick={handleDownload} 
        className="bg-[#03C9D7] hover:bg-[#02A5B3] text-white font-semibold py-2 px-6 rounded shadow-md transition duration-300 w-full"
      >
        Download Orders
      </button>
    </div>
  </div>
  

  );
};

export default OrderUploadDownload;
